import * as actions from '../actions';
import { globalGetService, globalPostService, globalPutService } from '../../../../globalServices/';
import { toastFlashMessage } from '../../../../utils/';
import { trackActivity } from '../../../../utils/mixpanel';
import { addObligation } from '../../contractAddObject';
import { browserHistory } from 'react-router'
export const contrObligationsAc = (params, query) => {
  return (dispatch) => {
    dispatch({
      type: actions.OBLIGATIONS_LOADER,
      payload: true
    });
    globalGetService('contracts/'+params.contract_slug+'/obligations/', query)
    .then(response => {
      if(response.data.statusCode == 200){
        dispatch({
          type: actions.CONTR_OBLIGATIONS_LIST,
          payload: response.data.data
        });
      }
      dispatch({
        type: actions.OBLIGATIONS_LOADER,
        payload: false
      });
    });
  }
}
export const obligationCrudFnAc = (params, type, id) => {
  return(dispatch) => {

    if(type == 'add'){
      dispatch({
        type: actions.OBLIGATION_CRUD,
        payload: {type: type, data:addObligation , flag: true }
      });
    }else{
      dispatch({
        type: actions.OBLIGATIONS_LOADER,
        payload: true
      });
      globalGetService('contracts/'+ params.contract_slug +'/obligations/'+id +'/',{})
      .then(response => {
        dispatch({
          type: actions.OBLIGATIONS_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch({
            type: actions.OBLIGATION_CRUD,
            payload: {type: 'view', data: response.data.data, flag: true }
          });
        }
      })
    }
  }
}

export const contrAddEditObligationsAc = (params, data, type, assetViewId) => {
  return (dispatch) => {
    dispatch({
      type: actions.OBLIGATIONS_LOADER,
      payload: true
    });
    if(type == 'add'){
      globalPostService('contracts/'+params.contract_slug+'/obligations/', data)
      .then(response => {
        dispatch({
          type: actions.OBLIGATIONS_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch(contrObligationsAc(params));
          toastFlashMessage(response.data.message, 'success');
          let assetTypeNames = {
            3: 'APU',
            4: 'LG',
            5: 'PROPELLER'
          }
          trackActivity('Item Added', {
            page_title: `Obligations`,
            application_module: `Contracts`,
            asset: assetViewId.asset_type === 1 ? `MSN ${assetViewId.msn}` : [3,4,5].includes(assetViewId.asset_type) ? `${assetTypeNames[assetViewId.asset_type]} ${assetViewId.serial_number}` : `ESN ${assetViewId.esn}`,
            contract_slug: params.contract_slug,
            item_type: `Obligations`,
            item_id: response.data.data.id
          })
        }
      })
    }else{
      globalPutService('contracts/'+params.contract_slug+'/obligations/' + data.id + '/',data)
      .then(response => {
        dispatch({
          type: actions.OBLIGATIONS_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch({
            type: actions.EDIT_OBLIGATION_SUCCESS,
            payload: response.data.data
          });
          dispatch({
            type: actions.OBLIGATION_CRUD,
            payload: {type: '', data: {}, flag: false }
          });
          toastFlashMessage(response.data.message, 'success');
          let assetTypeNames = {
            3: 'APU',
            4: 'LG',
            5: 'PROPELLER'
          }
          trackActivity('Item Edited', {
            page_title: `Obligations`,
            application_module: `Contracts`,
            asset: assetViewId.asset_type === 1 ? `MSN ${assetViewId.msn}` : [3,4,5].includes(assetViewId.asset_type) ? `${assetTypeNames[assetViewId.asset_type]} ${assetViewId.serial_number}` : `ESN ${assetViewId.esn}`,
            contract_slug: params.contract_slug,
            item_type: `Obligations`,
            item_id: data.id
          })
        }
      })
    }
  }
}

export const changeObligationStatusAc = (params,id, data) => {
  return (dispatch) => {
    globalPutService(`contracts/${params.contract_slug}/obligation-approval/${id}/`,data)
    .then(response => {
      if(response.data.statusCode == 200){
        browserHistory.push(`/${params.type}/${params.aircraft_slug}/contract/${params.contract_slug}/obligations`)
        dispatch(contrObligationsAc(params));
        toastFlashMessage(response.data.message, 'success');
      }
    })
  }
}
export const getApprovedByUserAc = (params, query)=>{
  return (dispatch) => {
    globalGetService('console/get-user-list/', query)
    .then(response => {
      if(response.data.statusCode == 200) {
        dispatch({
          type:actions.GET_APPROVED_BY_USER,
          payload:response.data.data
        })
      }
    })
  }
}
